import { Button, ButtonWithIcon, IconButton } from '@oy/uidesktop';
import { useDispatch } from 'react-redux';
import { AutoReportProvider } from 'src/components/AutoReportFormSideModal/AutoReportProvider';
import { useTranslate } from 'src/hooks';
import { BankMaintenanceSideModal } from 'src/pages/Disbursement/components/Maintenance/BankMaintenanceSideModal/BankMaintenanceSideModal';
import { ShortcutDisbursementProducts } from 'src/pages/Disbursement/components/ShortcutSideModal/constant';
import { ShortcutSideModal } from 'src/pages/Disbursement/components/ShortcutSideModal/ShortcutSideModal';
import { showChooseCreateModal } from '../../../redux/actions';
import styles from './BulkDisbursementCreationButton.module.css';
import { useBulkDisbursementCreationButton } from './useBulkDisbursementCreationButton';

type BulkDisbursementCreationButtonProps = {
  userHasMakerPermissionBulk: boolean;
};

function BulkDisbursementCreationButton({
  userHasMakerPermissionBulk,
}: BulkDisbursementCreationButtonProps) {
  const { getTranslation } = useTranslate();
  const dispatch = useDispatch();
  const { state, action } = useBulkDisbursementCreationButton();
  const {
    showVendorMaintenance,
    showSideModal,
    showShortcutSideModal,
    showAutoReportModal,
  } = state;

  const {
    handleToggleSideModal,
    closeShortcutSideModal,
    closeBankMaintenanceSideModal,
    openShortcutSideModal,
    setShowAutoReportModal,
    handleAutoReportModal,
    handleFaqModal,
  } = action;

  return (
    <div className={styles.container} id="coachBulkList4">
      {userHasMakerPermissionBulk && (
        <div
          onClick={() => {
            dispatch(showChooseCreateModal(true));
          }}
        >
          <ButtonWithIcon
            color={Button.Color.Primary}
            iconName="add"
            size={Button.Size.Small}
          >
            {getTranslation('common_createNewTransaction')}
          </ButtonWithIcon>
        </div>
      )}

      <IconButton
        isDedupe
        iconName="configs"
        color={IconButton.Color.Secondary}
        size={IconButton.Size.Medium}
        buttonType={IconButton.Type.SquareOutlined}
        className={styles.helpButton}
        onClick={openShortcutSideModal}
      />

      {showSideModal && (
        <BankMaintenanceSideModal
          source="button_bulk_disburse_list"
          show={showSideModal}
          handleToggleSideModal={closeBankMaintenanceSideModal}
        />
      )}

      <AutoReportProvider
        onClose={() => {
          setShowAutoReportModal(false);
          openShortcutSideModal();
        }}
        productName="BULK_DISBURSEMENT"
        showSideModalParent={showAutoReportModal}
        isShowToggleActivated={true}
      >
        {showShortcutSideModal && (
          <ShortcutSideModal
            productName={ShortcutDisbursementProducts.BULK_DISBURSEMENT}
            show={showShortcutSideModal}
            showVendorMaintenance={showVendorMaintenance}
            onClose={closeShortcutSideModal}
            handleToggleSideModal={handleToggleSideModal}
            handleAutoReportModal={handleAutoReportModal}
            handleFaqModal={handleFaqModal}
          />
        )}
      </AutoReportProvider>
    </div>
  );
}

export default BulkDisbursementCreationButton;
